export const categories = [
  {
    id: 1,
    title: "Kids Theme",
    image: "/images/ThemeImages/kids_theme_copy.webp",
    link: "#kids-theme"
  },
  {
    id: 2,
    title: "Baby Shower",
    image: "/images/ThemeImages/baby_shower_7b10b011-9dd4-427b-858e-4d0f7363c27a.webp",
    link: "#baby-shower"
  },
  {
    id: 3,
    title: "Welcome Baby",
    image: "/images/ThemeImages/welcome_baby_356973c5-d3b8-45c3-bde9-2d4814f67ec9.webp",
    link: "#welcome-baby"
  },
  {
    id: 4,
    title: "Bachelorette Party",
    subtitle: "Bride to be",
    image: "/images/ThemeImages/bachelorette_f6727649-6cfd-4f07-8036-786a645bd1f9.webp",
    link: "#bachelorette"
  },
  {
    id: 5,
    title: "Proposal",
    image: "/images/ThemeImages/proposal_copy.webp",
    link: "#proposal"
  },
  {
    id: 6,
    title: "Wedding Decor",
    image: "/images/ThemeImages/Wedding_c9b5e0ff-95cc-41c3-a745-8134a144d3cc.webp",
    link: "#wedding"
  }
];

